import React from 'react';
import Background from '../../components/Background/Background';
import { motion } from 'framer-motion';
import Header from '../../components/Header/Header';
import fadeIn from '../../animations/fadeIn';
import Logo from '../../components/Logo/Logo';
import Button from '../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { MobileView } from 'react-device-detect';
import { useAppSelector } from '../../hooks/useApp';

const About = () => {
  const navigate = useNavigate();
  const { source } = useAppSelector((state) => state.auth);

  return (
    <>
      <div className='fixed top-0 left-0 right-0 bottom-0 bg-[#002333] bg-opacity-[0.93] max-w-full z-10 backdrop-blur-sm' />
      <Background image='about'>
        <Header title='Learn More' />
        <motion.div
          className='frontpage-header'
          variants={fadeIn()}
          initial='hidden'
          animate='enter'
          exit='exit'
        >
          <div className='h-2' />
          <Logo name='ccc-horizontal' className='max-w-full' />
          <p className='font-normal w-full text-center'>
            Not able to meet your travel goal yet?
            <br />
            No problem.
          </p>
          <img src='/ccc-app.png' className='w-full' alt='cc-app' />
          <p className='font-normal w-full'>With Odynn Premium, you can:</p>
          <ul className='list-disc font-normal text-sm w-[90%]'>
            <li>Optimize your spending to earn the points or miles you need</li>
            <li>
              Earn $1,000-$3,000 back in the first 90 days through personalized
              recommendations
            </li>
            <li>Set and achieve other goals like charitable giving</li>
          </ul>
        </motion.div>
        <MobileView className='w-full'>
          <Button
            type='secondary'
            onClick={() => navigate('https://link.cardcurator.com/u9uD/awayz')}
          >
            Sign Up for 90-Day Free Trial
          </Button>
        </MobileView>
        <div className='w-full flex flex-col justify-center items-center gap-4'>
          <p className='text-white'>Download the Odynn Mobile App</p>
          <div className='flex gap-4 justify-center items-center w-[90%]'>
            <a
              className='flex-1 flex justify-center'
              href={`https://link.cardcurator.com/u9uD/${source ?? 'awayz'}`}
              target={'_blank'}
              rel='noreferrer'
            >
              <img
                src='/storeDownloads/apple.svg'
                className='h-12'
                alt='apple logo'
              />
            </a>
            <a
              className='flex-1 flex justify-center'
              href={`https://link.cardcurator.com/u9uD/${source ?? 'awayz'}`}
              target={'_blank'}
              rel='noreferrer'
            >
              <img
                src='/storeDownloads/google.png'
                className='h-12'
                alt='google logo'
              />
            </a>
          </div>
        </div>
      </Background>
    </>
  );
};

export default About;
